import { makeAutoObservable, action } from "mobx";
import repository from "src/repositories/Analysis";
import { Analyzers } from "src/types/analysis/schema";
import { SelectType, StoreState } from "src/types/common";

export default class Analysis {
  analyzers?: Analyzers;
  search_analyzers?: SelectType[];
  indexing_analyzers?: SelectType[];
  state: StoreState = "none";

  constructor() {
    makeAutoObservable(this);
  }

  readMany = action(async () => {
    this.state = "pending";

    try {
      const response = await repository.readMany();
      const searchAnalyzers = Object.entries(response.data.search_analyzers).map(([k, v]) => {
        return { label: k, value: v };
      });
      const indexingAnalyzers = Object.entries(response.data.indexing_analyzers).map(([k, v]) => {
        return { label: k, value: v };
      });

      this.search_analyzers = searchAnalyzers;
      this.indexing_analyzers = indexingAnalyzers;
      this.state = "done";
    } catch (e) {
      this.state = "error";
      throw e;
    }
  });

  async analyze(
    applicationId: string,
    indexName: string,
    text: string,
    analyzers: string
  ) {
    try {
      const res = await repository.analyze(
        applicationId,
        indexName,
        text,
        analyzers
      );
      return res.data;
    } catch (e) {
      throw e;
    }
  }

  async tokenize(text: string, tokenizers: string) {
    try {
      const res = await repository.tokenize(text, tokenizers);
      return res.data;
    } catch (e) {
      throw e;
    }
  }

  clear = action(async () => {
    this.state = "none";
  });
}
